import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import getters from './getters';
import mutations from './mutations';

export const serviceComputed = {
	...mapGetters('comCdPopupStore', Object.keys(getters)),
	...mapState('comCdPopupStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('comCdPopupStore', Object.keys(actions)),
	...mapMutations('comCdPopupStore', Object.keys(mutations))
};
